<template>
  <div class="two">
    <div v-for="row in rows" :key="row" class="labelbody">

      <div class="text-right">{{row.mainstorage.name}} {{row.localcollnumber}}</div><br>
      <div>
        <div class="font-weight-bold">{{row.store}}</div>

        <div v-for="col in meta.columns" :key="col">
          <base-geo-cell v-if = "col.fieldname === 'species'" v-bind="{mode:'labelprint', column:col, initValue:row[col.fieldname], meta:meta, rowobject:row}" v-model="row[col.fieldname]"/>
        </div>

      </div>
      <div class="d-flex flex-wrap">
        <span><point-widget v-bind="{mode:'view'}" v-model="row.coordinates"/></span> <span v-if="row.alt">. El.: {{row.alt}} m a.s.l. </span> 
      </div>
      {{row.location}}<br>
      <div class="d-flex flex-wrap">
      Leg.:&nbsp<date-widget v-bind="{mode:'view'}" v-model="row.legdate" />&nbsp{{row.legname2}}&nbsp<span v-if="row.legnum"> ({{row.legnum}}) </span><br>
    </div>
    <div class="d-flex flex-wrap" v-if = "row.species.rows[0] !== undefined">
      Det.:&nbsp<date-widget v-bind="{mode:'view'}" v-model="row.species.rows[0].detdate" />&nbsp{{row.species.rows[0].detname2}}<br>
    </div>
      <div class="text-right">LID: {{row.linkid}}</div>
      <div>- - - - - - - ✂ - - - - - - - </div>
      <p>&nbsp;</p>
      <!-- <div class="text-right">LID: {{row.linkid}} </div> <div v-if = "row.species.rows[0] !== undefined" > Sprows: {{ row.species.rows[0] }} </div> -->
    </div>
  </div>
</template>
<script>
import PointWidget from '@/components/widgets/PointWidget.vue';
import DateWidget from '@/components/widgets/DateWidget.vue';
//import DetailsWidget from '@/components/widgets/DetailsWidget.vue';
export default {
  name: 'standard-print-page',
  components: {
    PointWidget,
    DateWidget,
//    DetailsWidget,
  },
  props:['meta', 'rows'],
  data(){ 
    return {
        metadetails: {},
    }
  },

  mounted(){
  // this.getMetaAndUpdate();
  },

  methods: {

//     getMetaAndUpdate() {
      
//       this.metadetails = this.$store.state.columnPrint;
// //      console.log(this.metadetails);
//     },

  },

}
</script>

<style scoped>
@media print {
  .two {
    column-count: 2;
    gap: 1cm;
    column-rule: 1px dotted #666;
    font-family:'Arial';
    font-size: 12px;
  }
  .one {
    column-count: 1;
    -webkit-column-count: 1;
    -moz-column-count: 1;
  }
  @page {
    margin: 0.5cm;
  }
  .labelbody {
    page-break-inside: avoid;
  }
}
</style>